export const isValidSubDomain = subDomain => {
  return /^[0-9a-zA-Z_-]+$/.test(subDomain);
};
